export default "__VITE_ASSET__BTylaDei__"